import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const TileDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'block',
    position: 'relative',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    bg: theme.palette.common.white,
    color: theme.palette.primary.main
  }, props);
})``;

const _excluded$1 = ["theme"];
const TileHeaderDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    p: theme.spacing.md,
    borderBottom: `1px solid ${theme.palette.divider}`
  }, props);
})``;

const _excluded$2 = ["theme"];
const TileContentDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread2({
    p: theme.spacing.md,
    display: 'block',
    position: 'relative'
  }, props);
})``;

const _excluded$3 = ["theme"];
const TileFooterDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    p: theme.spacing.md,
    borderTop: `1px solid ${theme.palette.divider}`
  }, props);
})``;

function Tile({
  header,
  children,
  footer,
  onRenderHeader = null,
  onRenderFooter = null,
  styles = {},
  testIds = {}
}) {
  return /*#__PURE__*/createElement(TileDiv, _extends({
    testId: testIds.root
  }, styles.root), header || onRenderHeader ? onRenderHeader ? onRenderHeader() : /*#__PURE__*/createElement(TileHeaderDiv, _extends({
    testId: testIds.header
  }, styles.header), header) : null, children ? /*#__PURE__*/createElement(TileContentDiv, _extends({
    testId: testIds.content
  }, styles.content), children) : null, footer || onRenderFooter ? onRenderFooter ? onRenderFooter() : /*#__PURE__*/createElement(TileFooterDiv, _extends({
    testId: testIds.footer
  }, styles.footer), footer) : null);
}

export default Tile;
